import { FC } from "react";

type RowLabelProps = {
  label?: string;
  usePadding: boolean;
};

export const RowLabel: FC<RowLabelProps> = ({ label, usePadding }) => {
  return (
    <dt
      className={`text-primary flex items-center ${
        usePadding ? "py-5 px-4" : ""
      }`}
    >
      <div className="min-w-0 truncate">{label}</div>
    </dt>
  );
};
